import { createTheme } from '@mui/material/styles';

// assets
import colors from 'assets/scss/_themes-vars.module.scss';

// project imports
import componentStyleOverrides from './compStyleOverride';
import themePalette from './palette';
import themeTypography from './typography';

export const theme = () => {
    const color = colors;

    const themeOption = {
        colors: color,
        heading: color.red700,
        paper: color.paper,
        backgroundDefault: color.paper,
        background: color.primaryLight,
        darkTextPrimary: color.darkTextHint1,
        darkTextSecondary: color.grey500,
        textDark: color.grey900,
        divider: color.grey200,
        borderRadius: '4px',
        secondBorderRadius: '0.5rem',
        boxBoxShadow: 'rgba(0, 0, 0, 0.05) 0rem 1.25rem 1.6875rem 0rem',
        boxBorderShadow: 'rgba(20, 20, 20, 0.12) 0rem 0.25rem 0.375rem -0.0625rem, rgba(20, 20, 20, 0.07) 0rem 0.125rem 0.25rem -0.0625rem',
        mainBorderRadius: '10px',
        fontFamily: `'Pretendard', sans-serif`
    };

    const themeOptions = {
        direction: 'ltr',
        palette: themePalette(themeOption),
        mixins: {
            toolbar: {
                minHeight: '48px',
                padding: '16px',
                '@media (min-width: 600px)': {
                    minHeight: '48px'
                }
            }
        },
        components: {
            MuiContainer: {
                styleOverrides: {
                    maxWidthSm: {
                        maxWidth: 200
                    },
                    maxWidthMd: {
                        maxWidth: 200
                    },
                    maxWidthLg: {
                        maxWidth: 200
                    }
                }
            }
        },
        typography: themeTypography(themeOption)
    };

    const themes = createTheme(themeOptions);
    themes.components = componentStyleOverrides(themeOption);

    return themes;
};

export default theme;
